import script from "./MediaButtons.vue?vue&type=script&setup=true&lang=js"
export * from "./MediaButtons.vue?vue&type=script&setup=true&lang=js"

import "./MediaButtons.vue?vue&type=style&index=0&id=990ede20&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-990ede20"]])

export default __exports__